var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 30,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.508246 15.978H3.96197V29.5161C3.96197 29.7834 4.18942 30 4.47015 30H10.3261C10.6068 30 10.8343 29.7834 10.8343 29.5161V16.0418H14.8047C15.0628 16.0418 15.2801 15.8573 15.3095 15.6132L15.9126 10.6291C15.9291 10.492 15.8835 10.3547 15.7871 10.2518C15.6907 10.1488 15.5527 10.0899 15.4078 10.0899H10.8345V6.96562C10.8345 6.02385 11.3671 5.54625 12.4177 5.54625C12.5674 5.54625 15.4078 5.54625 15.4078 5.54625C15.6886 5.54625 15.916 5.32957 15.916 5.06238V0.487441C15.916 0.220137 15.6886 0.00357422 15.4078 0.00357422H11.2869C11.2578 0.00222656 11.1933 0 11.0982 0C10.3831 0 7.89778 0.133652 5.93452 1.85332C3.75926 3.75902 4.06166 6.04072 4.13391 6.43635V10.0898H0.508185C0.227446 10.0898 0 10.3063 0 10.5737V15.4941C6.15385e-05 15.7613 0.227508 15.978 0.508246 15.978Z",
    fill: "#385C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e5c28d52.svg";
export { ForwardRef as ReactComponent };